module.exports = __webpack_public_path__ + "img/methods (1).e0eb4bf9.png";